import LoadingScreen from '../../components/shared/LoadingScreen/LoadingScreen';
import CardService from '../../services/card.service';
import { useEffect } from 'preact/hooks';
import NavigationUtils from '../../utils/navigation.utils';

export default function SetPinStatusPage({
  organization,
  cardUid,
  cardNumber,
}) {
  useEffect(() => {
    try {
      CardService.setPinStatus(organization, cardUid)
        .then(response => {
          const page = response.status.toLowerCase();
          let newUrl = window.location.href.includes('/reset-pin')
            ? `${NavigationUtils.Routes.RESET_PIN_STATUS}/${page}`
            : `${NavigationUtils.Routes.SET_PIN_STATUS}/${page}`;

          NavigationUtils.navigate(newUrl, true, {
            cardUid,
            cardNumber,
            activation: response.activationProcess,
          });
        })
        .catch(e => {
          console.error(`Could not redirect to final url`, e);
          NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN, true, {
            cardUid,
            cardNumber,
          });
        });
    } catch (e) {
      console.error(`Could not send set pin status to backend`, e);
      NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN, true, {
        cardUid,
        cardNumber,
      });
    }
  }, []);

  return <LoadingScreen />;
}
